import { Box } from "@mui/material";

import CreateDeviceTemplate from "./components/CreateDeviceTemplate";
import DeviceTemplatesTable from "./components/DeviceTemplatesTable";

const DeviceTemplatesPage = (): JSX.Element => {
  return (
    <Box>
      <Box padding="0.75em 0">
        <CreateDeviceTemplate />
      </Box>
      <DeviceTemplatesTable />
    </Box>
  );
};

export default DeviceTemplatesPage;
